module.exports = __webpack_public_path__ + "c7f8397ff46f058e794da8266efb4013.svg";